import { VideoStatus } from '../../../enums';
import { Event, EventVideo as EventVideoType } from '../../../interfaces';
import { isSentToProcessor } from '../../../utils';
import { getSentToProcessorStatus } from '../../../utils/sentToProcessorStatus';

export const getMediaStatus = (event: Event): VideoStatus | string => {
  const videos: EventVideoType[] = [];

  if (isSentToProcessor(event)) {
    return getSentToProcessorStatus(event);
  }

  if (event?.event_videos) {
    videos.push(...event.event_videos);
  }

  if (event?.sub_events?.length > 0) {
    const subEventVideos = event.sub_events.reduce((acc, event) => {
      acc.push(...(event?.event_videos || []));
      return acc;
    }, []);
    videos.push(...subEventVideos);
  }

  let mediaStatus = VideoStatus.noneStr;

  if (videos.length > 0) {
    mediaStatus = videos[0].status;
  }

  return mediaStatus;
};
